import { SxProps, Theme } from '@mui/material/styles';

export const purchaseRootSX: SxProps<Theme> = {
	mb: { xs: '48px', md: '80px' },
	p: { xs: '16px', md: '20px 24px' },
	borderRadius: '12px',
	background: '#F4F5F7',
	display: 'flex',
	flexDirection: { xs: 'column', md: 'row' },
	alignItems: { xs: 'stretch', md: 'center' },
	justifyContent: 'space-between',
	gap: { xs: '12px', md: '32px' },
};

export const purchaseProductSX: SxProps<Theme> = {
	display: 'flex',
	alignItems: 'center',
	gap: '16px',
	minWidth: 0,
};

export const purchaseImageSX: SxProps<Theme> = {
	flexShrink: 0,
	width: { xs: '64px', md: '72px' },
	height: { xs: '64px', md: '72px' },
	borderRadius: '8px',
	overflow: 'hidden',
	background: '#E6E8EC',
	'& img': {
		display: 'block',
		width: '100%',
		height: '100%',
		objectFit: 'cover',
	},
};

export const purchaseInfoSX: SxProps<Theme> = {
	display: 'flex',
	flexDirection: 'column',
	gap: '2px',
	minWidth: 0,
};

export const purchaseEyebrowSX: SxProps<Theme> = {
	m: 0,
	fontSize: '10px',
	fontWeight: 700,
	letterSpacing: '0.16em',
	textTransform: 'uppercase',
	color: '#6b6b6b',
};

export const purchaseNameSX: SxProps<Theme> = {
	m: 0,
	fontSize: { xs: '15px', md: '16px' },
	fontWeight: 800,
	lineHeight: 1.3,
	color: '#2c2c2c',
};

export const purchaseDetailSX: SxProps<Theme> = {
	m: 0,
	fontSize: '12px',
	color: '#6b6b6b',
};

export const purchaseTextSX: SxProps<Theme> = {
	m: 0,
	maxWidth: { md: '320px' },
	fontSize: '13px',
	lineHeight: 1.5,
	color: '#505050',
};
